import TextM from "@common/components/text/TextM"
import TitleM from "@common/components/text/TitleM"
import { HeaderContainerM } from "@common/header/HeaderContainerM"
import StudentMainMenuHeader from "@common/header/StudentMainMenuHeader"
import { PaginatedFlatList } from "@common/screens/PaginatedFlatList"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { activitiesService } from "@data/services/activitiesService"
import { hasRole } from "@data/utility/ability"
import { findItemInListWithId } from "@data/utility/dataUtils"
import { StatusBar } from "@common/systemBars/StatusBar"
import React, { useContext, useMemo, useRef, useState } from "react"
import { Dimensions, Platform, View } from "react-native"
import { IconButton } from "react-native-paper"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import BecomePremiumCard from "../../account/subscription/BecomePremiumCard"
import ReadReviewRequestHandler from "../../activity/read/ReadReviewRequestHandler"
import { ChampionImageM } from "../../champions/ChampionImageM"
import RealizationsListItem from "./RealizationsListItem"
import RealizationsSearchBar from "./RealizationsSearchBar"
import {
    EMPTY_ACTIVITY_SEARCH,
    pickSearchSubjects,
} from "../../../ports/primary/ui/formatters/activitySearchFormatter"
import { useFinishedActivitiesParams } from "../../../ports/primary/ui/hooks/useFinishedActivitiesParams"
import TodoModal from "../../activity/todo/TodoModal"
import { parentOnlyBridge } from "../../../featureFlags/screenBridge"
import { RealizationsScreen as PortsRealizationsScreen } from "../../../ports/primary/ui/screens/parent/Activities/RealizationsScreen"

// Le même écran est monté dans l'espace parent : l'élève est tutoyé, le parent
// lit une version sans pronom.
const TEXTS = {
    student: {
        emptyTitle: "Tu n'as pas encore réalisé d'activité",
        emptySubtitle:
            "Réalise ta première activité pour accéder à tes scores et des conseils personnalisés pour t'améliorer",
    },
    parent: {
        emptyTitle: "Aucune activité réalisée pour l'instant",
        emptySubtitle:
            "Les scores et les conseils personnalisés apparaîtront dès la première activité réalisée",
    },
}

const LegacyRealizationsTabScreen = (props) => {
    // ** Component props
    const { navigation, student, centerTitle } = props

    const texts = TEXTS[props.isParentMode ? "parent" : "student"]

    const studentId = props.route?.params?.studentId ?? null

    const insets = useSafeAreaInsets()

    const liveSession = props.currentLiveSession

    const user = !studentId
        ? student
            ? student
            : props.user
        : findItemInListWithId(studentId, liveSession?.users) ??
          findItemInListWithId(studentId, props.user?.students)

    const requestApiService =
        student || studentId
            ? activitiesService.getStudentFinishedActivities
            : activitiesService.getFinishedActivities
    const requestRouteParams = student
        ? { id: student?.id }
        : studentId
        ? { id: studentId }
        : {}

    // ** Manage scrolling to specific index in flat list
    const flatListRef = useRef()

    const finishedActivities = user?.history?.activities
    const dimensions = useContext(DimensionsContext)

    // La recherche part au serveur : elle parcourt toutes les activités faites, pas la page chargée.
    const [search, setSearch] = useState(EMPTY_ACTIVITY_SEARCH)
    const searchParams = useFinishedActivitiesParams(search)
    const finishedMeta = user?.history?.activities_meta
    const searchSubjects = useMemo(
        () => pickSearchSubjects(finishedMeta?.school_subject_ids, props.schoolSubjects ?? []),
        [finishedMeta?.school_subject_ids, props.schoolSubjects]
    )

    const [isTodoModalOpen, setTodoModalOpen] = useState(false)
    const [selectedActivityId, setSelectedActivityId] = useState(null)
    const selectedActivity = findItemInListWithId(selectedActivityId, finishedActivities)

    return (
        <View
            style={{
                flex: 1,
            }}
        >
            {(hasRole(props.user, "tutor") || props.isParentMode) && (
                <View
                    style={{
                        paddingVertical: 5,
                        paddingTop: insets.top + 5,
                        backgroundColor: theme.colors.white,
                        paddingRight: 10,
                        borderBottomWidth: 1,
                        borderColor: theme.colors.lightMore,
                    }}
                >
                    <StudentMainMenuHeader studentId={studentId} withGoBack />
                </View>
            )}

            {user?.xp > 0 || user?.activities?.length > 0 ? (
                <View
                    style={{
                        flex: 1,
                        alignItems: "center",
                        width:
                            Platform.OS === "web"
                                ? Dimensions.get("window").width
                                : null,
                        alignSelf: "center",
                    }}
                >
                    {(hasRole(props.user, "tutor") || props.isParentMode) && (
                        <TitleM
                            style={{ marginTop: 10 }}
                            fontWeight="ExtraBold"
                            wrap
                        >
                            ACTIVITÉS TERMINÉES
                        </TitleM>
                    )}

                    {hasRole(props.user, "student") && !props.isParentMode && (
                        <HeaderContainerM
                            style={{
                                justifyContent: "center",
                                paddingRight: 15,
                                flexDirection: "row",
                                width: dimensions?.width,
                            }}
                        >
                            <IconButton
                                icon={"times"}
                                iconColor={theme.colors.primary}
                                containerColor={theme.colors.transparent}
                                size={30}
                                style={{
                                    position: "absolute",
                                    left: 4,
                                }}
                                onPress={() => {
                                    if (navigation.canGoBack())
                                        navigation.goBack()
                                    else navigation.replace("menu")
                                }}
                            />
                            <TextM
                                fontSize={20}
                                fontWeight={"ExtraBold"}
                                color={theme.colors.primary}
                                style={{ textAlign: "center" }}
                                wrap
                            >
                                ACTIVITÉS FAITES
                            </TextM>
                        </HeaderContainerM>
                    )}

                    <RealizationsSearchBar
                        search={search}
                        onChange={setSearch}
                        subjects={searchSubjects}
                        resultCount={finishedMeta?.total}
                        width={
                            Platform.OS !== "web" || dimensions?.width < 800
                                ? dimensions?.width
                                : dimensions?.width / 1.2
                        }
                    />

                    <PaginatedFlatList
                        data={finishedActivities}
                        ref={flatListRef}
                        style={{
                            width:
                                Platform.OS !== "web"
                                    ? dimensions?.width
                                    : "100%",
                        }}
                        contentContainerStyle={{
                            alignItems: "center",
                        }}
                        additionalOnRefresh={() => {}}
                        additionalRefreshing={false}
                        requestApiService={requestApiService}
                        requestRouteParams={requestRouteParams}
                        requestUrlParams={searchParams}
                        // Une recherche qui change recharge la page 1 ; sans résultat, le retour sur l'écran ne la relance pas.
                        noRefreshWhenNoResults
                        requestData={null}
                        ListHeaderComponent={
                            <>
                                <View
                                    style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: centerTitle
                                            ? "center"
                                            : "space-between",
                                        width:
                                            Platform.OS !== "web"
                                                ? dimensions?.width
                                                : "100%",
                                        borderColor: theme.colors.lightMore,
                                        paddingVertical: 15,
                                        paddingHorizontal: 10,
                                    }}
                                ></View>
                                <BecomePremiumCard
                                    index={0}
                                    style={{
                                        marginTop: 0,
                                        marginBottom: 20,
                                        alignSelf: "center",
                                    }}
                                />
                            </>
                        }
                        renderItem={(item) => {
                            return (
                                <RealizationsListItem
                                    activity={item.item}
                                    custom
                                    student={
                                        !!studentId || !!student ? user : null
                                    }
                                    todo={hasRole(props.user, "tutor") || props.isParentMode}
                                    onPress={hasRole(props.user, "tutor") || props.isParentMode ? () => {
                                        setSelectedActivityId(item.item?.id)
                                        setTodoModalOpen(true)
                                    } : undefined}
                                    withGoBack={props.isLive}
                                    onPressCallback={() => {
                                        if (props.isLive) {
                                            navigation.goBack()
                                        }
                                    }}
                                />
                            )
                        }}
                    />
                    <ReadReviewRequestHandler />

                    <StatusBar
                        style="dark"
                        backgroundColor={theme.colors.white}
                        translucent={false}
                    />

                    {isTodoModalOpen && (hasRole(props.user, "tutor") || props.isParentMode) && (
                        <TodoModal
                            isOpen={isTodoModalOpen}
                            handleShowModal={() => setTodoModalOpen(!isTodoModalOpen)}
                            item={selectedActivity}
                            itemId={selectedActivity?.id}
                            navigation={navigation}
                            studentId={user?.id}
                            schoolSubject={findItemInListWithId(
                                selectedActivity?.school_subject_id,
                                props.schoolSubjects
                            )}
                        />
                    )}
                </View>
            ) : (
                <View
                    style={{
                        alignItems: "center",
                        justifyContent: "center",
                        paddingHorizontal: 20,
                        flex: 1,
                        width: Platform.OS === "web" ? dimensions?.width : null,
                        alignSelf: "center",
                    }}
                >
                    <ChampionImageM name="sam" variant={"main"} width={90} />
                    <TitleM
                        fontWeight="ExtraBold"
                        style={{ textAlign: "center", marginTop: 20 }}
                        wrap
                    >
                        {texts.emptyTitle}
                    </TitleM>
                    <TextM
                        fontWeight="Medium"
                        style={{ textAlign: "center" }}
                        wrap
                    >
                        {texts.emptySubtitle}
                    </TextM>
                    <StatusBar
                        style="dark"
                        backgroundColor={theme.colors.white}
                        translucent={false}
                    />
                </View>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        removeSchoolSubjectRequest: state.api.removeSchoolSubject?.request,
        removeSchoolSubjectSuccess: state.api.removeSchoolSubject?.success,
        removeSchoolSubjectError: state.api.removeSchoolSubject?.error,
        removeSchoolSubjectSuccessData: state.api.removeSchoolSubject?.data,

        getStudentRequest: state.api.getStudent?.request,
        getStudentSuccess: state.api.getStudent?.success,
        getStudentError: state.api.getStudent?.error,

        getUserRequest: state.api.getUser?.request,
        getUserSuccess: state.api.getUser?.success,
        getUserError: state.api.getUser?.error,
        activityTemplates: state.data.staticData?.activity_templates,
        user: state.data.currentUser?.object,
        isParentMode: state.data.family?.isParentMode,
        maxPrioritizedSchoolSubjects:
            state.data.staticData?.max_prioritized_school_subjects,
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),

        isLive: state.liveMode?.isLiveModeEnabled,
        schoolSubjects: state.data.staticData?.school_subjects,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

const ConnectedLegacyRealizationsTabScreen = connect(
    mapStateToProps,
    mapDispatchToProps
)(LegacyRealizationsTabScreen)

/**
 * « Activités terminées » — pont **mode parent seulement** : l'écran sert aussi
 * l'élève et le tuteur. Le chemin du design system monte lui-même la fiche d'une activité
 * (`useActivityDetailsFlow`).
 */
export default parentOnlyBridge(
    PortsRealizationsScreen,
    ConnectedLegacyRealizationsTabScreen
)
